import React from "react";
import ManageColumns from "assets/vectors/crm/show_columns.svg";
import { Button, InteractiveTooltip } from "@my-scoot/component-library-legacy";
import ExlyImage from "common/Components/ExlyImage";
import { useIsDesktop } from "features/Common/modules/Viewport/utils/Viewport.utils";

export const ManageColumnsButton = ({ handleClick = () => {} }) => {
  const isTooltipOpen = false;
  const isDesktop = useIsDesktop();
  const onClose = () => {};
  return (
    <InteractiveTooltip
      open={isTooltipOpen}
      title="To edit the custom columns, revisit this section and click on edit icon beside the column."
      customFooter={
        <div className="tw-flex tw-justify-end">
          <Button
            onClick={onClose}
            size="thin"
            buttonWrapperClassName="!tw-w-min"
          >
            Got it
          </Button>
        </div>
      }
      onCloseClick={onClose}
      totalSteps={0}
      enterDelay={0}
      leaveDelay={0}
      placement="bottom"
      tooltipClasses={{
        popper: `tw-z-[9999999999] ${isDesktop ? "tw-mt-4" : "tw-mt-0"}`,
      }}
      titleClassName="tw-text-[#272522] tw-text-[14px] tw-font-normal tw-leading-[18px] tw-tracking-[0.28px] tw-mb-4"
    >
      <Button
        color="tertiary"
        variant="outlined"
        onClick={handleClick}
        size="medium"
        aria-controls="simple-menu"
        aria-haspopup="true"
        style={{ position: "relative" }}
      >
        {isTooltipOpen && (
          <div className="tw-z-[10001] tw-fixed tw-inset-[-12px] tw-shadow-[0_0_0_9999px_rgba(39,37,34,0.3)]"></div>
        )}
        <ExlyImage
          src={ManageColumns}
          alt={"show-column"}
          height={13}
          width={13}
          className="tw-mr-[11px]"
        />
        Add/Manage columns
      </Button>
    </InteractiveTooltip>
  );
};
